import React from 'react';
import Icon from '../icons/Icon';
import './ExpandCollapseButton.css';

export default props => <div className={'ExpandCollapseButton ' + (
        props.expanded
        ? 'expanded'
        : 'collapsed')} style={props.style} onClick={props.onClick}>
    <Icon className="full-center" src="/img/chevron-left-white.png" color={props.color} size={18} />
</div>;
